import React from "react";
import "../css/management.css";
import sanjay from "../img/sanjay.jpeg";
import kanchan from "../img/team/kanchan-gupta.jpg";
import ourjourneybanner from "../img/management.jpeg";
function Management() {
  return (
    <div>
      <div
        className="sx-bnr-inr overlay-wraper bg-parallax bg-top-center"
        data-stellar-background-ratio="0.5"
        style={{ backgroundImage: `url(${ourjourneybanner})` }}
      >
        <div className="overlay-main bg-black opacity-07" />
        <div className="container">
          <div className="sx-bnr-inr-entry">
            <div className="banner-title-outer">
              <div className="banner-title-name">
                <h2 className="m-tb0">Our Management</h2>
                {/* <p>The essence of interior design will always be about people and how they live. It is about the realities of what makes for an attractive, civilized.</p> */}
              </div>
            </div>
            {/* BREADCRUMB ROW */}
            <div></div>
            {/* BREADCRUMB ROW END */}
          </div>
        </div>
      </div>
      <div className="management-content">
        <h3>Sanjay Gupta</h3>
        <img src={sanjay} alt="Sanjay Gupta"></img>
        <p>
        Spinoff Technopark Private Limited was founded in the year 2008 by Mr Sanjay Gupta , who is a Chartered  Accountant & Company Secretary. He has 
diversified experience of more than 35   years in various fields  of Finance, Accounts, Taxation, Import, Export, Logistics, Banking, Secretarial, 
Operation, Administration, Networking and Organizational Development.

        </p>
        <h3>Kanchan Gupta</h3>
        <img src={kanchan} alt="Kanchan gupta"></img>
        <p>
        Mrs Kanchan Gupta is the co-founder of the company. She is  a Graduate and is involved in administrative decision making, formulation of new business strategies, participation in overall retail stores' operation with respect  to fund flow & customer feedback . She is also looking after the staff's welfare needs & providing the back end support to the staff including the training and motivation to the employees.
        </p>
      </div>
    </div>
  );
}

export default Management;
